export default __webpack_public_path__ + "static/media/InoxidableWhite.a45cd7da.png";